// AUTO-GENERATED — do not edit. Source: /shared/. Run scripts/sync-shared.sh to update.
/**
 * Local-calendar-date helpers.
 *
 * Use these instead of `d.toISOString().split('T')[0]` / `.slice(0,10)`, which return
 * the *UTC* date. For users behind UTC (e.g. America/New_York, UTC-4/-5) every evening
 * after ~8pm that rolls to "tomorrow" — mislabeling "today", bookings, check-ins, and
 * daily reports. `ymd()` always returns the LOCAL calendar day.
 */

/** Local `YYYY-MM-DD` for a date (defaults to now). */
export function ymd(d: Date = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Parse a `YYYY-MM-DD` string as a LOCAL date at midnight (avoids the UTC-parse off-by-one). */
export function parseYmd(s: string): Date {
  const [y, m, d] = String(s).split('-').map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
}
